import * as R from 'ramda'
import Cookies from 'js-cookie'
import React, { Fragment, useState, useContext } from 'react'
import logoImage from '../../static/images/top_logo_w.png'
import G from '../../util/globalFunction'
import { GlobalContext } from '../../context/globalContext'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThList } from '@fortawesome/free-solid-svg-icons'

const MobileMenus = ({ title, menus, flag, registeOpenMenu }) => (
    <li>
        <a className="depth1_m" onClick={() => registeOpenMenu(title)}>
            {title}
        </a>
        <ul className="depth2 block">
            {flag &&
                menus.map(({ title, menus: children }, index) => (
                    <li key={index}>
                        <a>{title}</a>
                        <ul className="depth3 block">
                            {children.map(({ title, route }, index) => (
                                <li key={index}>
                                    <Link to={route}>{title}</Link>
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
        </ul>
    </li>
)

export default props => {
    const { menus, subMenu, handleOpenSubmenu } = props
    const [unfold, setUnfold] = useState(true)
    const [openMenus, setOpenMenus] = useState([])
    const msize = G.getMediaSize()
    const globalContext = useContext(GlobalContext)
    const { loginInfo, logout } = globalContext
    const { loggined } = loginInfo()

    const handleLoginClick = e => {
        e.preventDefault()

        if(loggined){
            if(window.confirm(G.t('trem.lang.home.0904'))){
                logout()
                G.gotoLoginPage()
            }
        }else{
                G.gotoLoginPage()
        }    /* 로그아웃 하시겠습니까? */
    }

    const handleGotoHome = R.pipe(
        e => e.preventDefault(),
        () => G.gotoPage('/')
    )

    const toggleMobileMenu = e => {
        e.preventDefault()
        setUnfold(!unfold)
    }

    const registeOpenMenu = title =>
        R.pipe(
            R.ifElse(
                () => openMenus.includes(title),
                () => {
                    const tmp = []
                    for (const t of openMenus) {
                        if (t !== title) {
                            tmp.push(t)
                        }
                    }
                    return tmp
                },
                () => [...openMenus, title]
            ),
            setOpenMenus
        )()

    const sendHello = e => {
        e.preventDefault()
        console.log('여기에 설정')
    }

    const currentLang = Cookies.get('__floor_lang__') || 'ko'
    const toggleLang = e => {
        e.preventDefault()
        Cookies.set('__floor_lang__', currentLang === 'ko' ? 'en' : 'ko')
        refresh()
    }

    const maskClassName = !unfold && ['sm', 'md'].includes(msize) ? 'mask show' : 'mask'
    const mobileMenuClassName = !unfold && ['sm', 'md'].includes(msize) ? 'all_menu_wrap' : 'hidden'

    return (
        <div
            className="flex-none flex flex-row items-center gap-2 px-2"
            style={{ backgroundColor: '#15183e', height: 50 }}
        >
            <img
                className="flex-none my-auto mx-2"
                src={logoImage}
                alt="logo image"
                onClick={handleGotoHome}
            />
            <div
                className={`flex-grow h-full hidden md:grid grid-cols-${menus.length} cursor-pointer`}
            >
                {menus.map((menu, index) => (
                    <div
                        className={`h-full text-gray-100 flex items-center justify-center text-center ${
                            subMenu && menu.title === subMenu.title
                                ? 'bg-blue-700'
                                : 'text-gray-100 '
                        }`}
                        key={index}
                        onClick={e => {
                            e.preventDefault()
                            handleOpenSubmenu(menu)
                        }}
                    >
                        {menu.title}
                    </div>
                ))}
            </div>

            <a
                className="md:hidden flex-grow text-white flex justify-end cursor-pointer"
                onClick={toggleMobileMenu}
            >
                <FontAwesomeIcon icon={faThList} size="2x" />
            </a>

            <div className="flex-none bg-white hidden xl:flex flex-row items-center rounded-md text-sm">
                <div className="px-2 py-1">00:00:00</div>
                <div className="px-2 py-1 rounded-r-md" style={{ backgroundColor: '#e2e3e4' }}>
                    {G.t('trem.lang.home.0007')}{/* 연장하기 */}
                </div>
            </div>
            <div className="flex-none bg-white hidden lg:flex  flex-row items-center rounded-md text-sm">
                <div className="px-2 py-1">관리자[테스트입니다.]</div>
                <div className="px-2 py-1 rounded-r-md" style={{ backgroundColor: '#e2e3e4' }}>
                    Logout
                </div>
            </div>

            <div className={mobileMenuClassName}>
                <div className="all_top">
                    <ul>
                        <li>
                            <a className="login" onClick={handleLoginClick}>
                                {loggined ? G.t('trem.lang.home.0004') : G.t('trem.lang.home.0001')}
                                {/* loggined ? 로그아웃 : 로그인 */}
                            </a>
                        </li>
                        {loggined ? (
                            <Fragment>
                                <li>
                                    <Link to="/">{G.t('trem.lang.home.0005')}</Link>{/* 마이페이지 */}
                                </li>
                                <li>
                                    <Link to="/">{G.t('trem.lang.home.0006')}</Link>{/* 운영 */}
                                </li>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <li>
                                    <a href="">{G.t('trem.lang.home.0002')}</a>{/* 회원가입 */}
                                </li>
                                <li>
                                    <a href="">{G.t('trem.lang.home.0003')}</a>{/* 아이디찾기 */}
                                </li>
                            </Fragment>
                        )}
                    </ul>
                    <a href="" className="language">
                        ENG
                    </a>
                    <a className="close" onClick={toggleMobileMenu}>
                        {G.t('trem.lang.home.0146')}
                        {/* 닫기 */}
                    </a>
                </div>
                {loggined && (
                    <div className="all_user">
                        <a onClick={() => G.gotoPage('/myPage/hm/user/info')} className="top_name">
                            [ <span>{NAME}</span>님 환영합니다 ]
                        </a>
                        <span id="counter">0:00:00</span>
                        <a id="timeClearBtn" onClick={sendHello} className="top_time">
                            {G.t('trem.lang.home.0007')}{/* 연장하기 */}
                        </a>
                    </div>
                )}
                <div className="all_con">
                    <ul className="depth1">
                        {menus.map((menu, index) => (
                            <MobileMenus
                                key={index}
                                {...menu}
                                registeOpenMenu={registeOpenMenu}
                                flag={openMenus.includes(menu.title)}
                            />
                        ))}
                    </ul>
                </div>
            </div>
            <div className={maskClassName}></div>
        </div>
    )
}
